import script from "./songadd.vue?vue&type=script&setup=true&lang=js"
export * from "./songadd.vue?vue&type=script&setup=true&lang=js"

import "./songadd.vue?vue&type=style&index=0&id=79a10315&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79a10315"]])

export default __exports__